/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TapeMiniReference,
    TapeMiniReferenceFromJSON,
    TapeMiniReferenceFromJSONTyped,
    TapeMiniReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface TapeGroup
 */
export interface TapeGroup {
    /**
     * 
     * @type {number}
     * @memberof TapeGroup
     */
    id: number;
    /**
     * 
     * @type {Array<TapeMiniReference>}
     * @memberof TapeGroup
     */
    tapes: Array<TapeMiniReference>;
    /**
     * 
     * @type {string}
     * @memberof TapeGroup
     */
    name: string;
}

export function TapeGroupFromJSON(json: any): TapeGroup {
    return TapeGroupFromJSONTyped(json, false);
}

export function TapeGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): TapeGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'tapes': ((json['tapes'] as Array<any>).map(TapeMiniReferenceFromJSON)),
        'name': json['name'],
    };
}

export function TapeGroupToJSON(value?: TapeGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'tapes': ((value.tapes as Array<any>).map(TapeMiniReferenceToJSON)),
        'name': value.name,
    };
}


